import React from 'react';
import { Form } from 'react-bootstrap';
import CreatableSelect from "react-select/creatable";
import { FilterPopover } from "../../components";

interface IImagesAutomaticFilterProps {
    threshold: number;
    maxNumberOfManuals: number;
    manufacturerOptions: any[];
    selectedManufacturers: any[];
    onThresholdChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onNumberChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onChangeManufacturers: (items: any) => void;
    t: (key: string) => string;
    handleApplyFilter: (event: React.FormEvent) => void;
    isLoading: boolean;
}

const ImagesAutomaticSelectionFilter: React.FC<IImagesAutomaticFilterProps> = ({
    threshold,
    maxNumberOfManuals: manualsBasedOnImages,
    manufacturerOptions: manufacturers,
    selectedManufacturers,
    onThresholdChange,
    onNumberChange,
    onChangeManufacturers,
    isLoading,
    t,
    handleApplyFilter,
}) =>
(
    <FilterPopover
        id="images-automatic-filter"
        title={t("OnlyMatchToOEM.FilterTitle")}
        isLoading={isLoading}
        onApplyFilter={handleApplyFilter}
        t={t}
    >
        <Form.Group>
            <Form.Label>{t("AutomaticImageSelection.Threshold")}: {threshold}</Form.Label>
            <Form.Control
                type="range"
                min="0"
                max="1"
                step="0.1"
                value={threshold}
                disabled={isLoading}
                onChange={onThresholdChange}
                className="dropdown-menu-wide mx-auto"
            />
        </Form.Group>
        <Form.Group>
            <Form.Label>{t("PdfFileUpload.TopKResults")}</Form.Label>
            <Form.Control
                type="number"
                value={manualsBasedOnImages}
                onChange={onNumberChange}
                disabled={isLoading}
                className="dropdown-menu-wide mx-auto"
            />
        </Form.Group>
        <Form.Group>
            <Form.Label>{t("Filter.manufacturer")}(s)</Form.Label>
            <CreatableSelect
                className="card border-0 d-md-block"
                closeMenuOnSelect={false}
                isMulti
                options={manufacturers}
                defaultValue={selectedManufacturers}
                placeholder={t("Filter.manufacturer")}
                isSearchable
                isDisabled={isLoading}
                onChange={onChangeManufacturers}
            />
        </Form.Group>
    </FilterPopover>
);

export default ImagesAutomaticSelectionFilter;
